export const uiLanguages = ["int", "no", "se", "dk", "fi", "fr", "de"] as const;

// sync with https://github.com/cvpartner/cvpartner/blob/9fa168aa685b8dbc7e6f92d49b78e56899467bae/lib/utils/country_code.rb#L6-L11
// & https://github.com/cvpartner/cvpartner/blob/9fa168aa685b8dbc7e6f92d49b78e56899467bae/lib/utils/language_code.rb#L8-L12
export const defaultCountryLanguageMapper = new Map([
  ["ae", "ar"], // country United Arab Emirates - Arabic
  ["al", "sq"], // country Albania - Albanian
  ["am", "hy"], // country Armenia - Armenian
  ["ao", "pt"], // country Angola - Portuguese
  ["ar", "es"], // country Argentina - Spanish
  ["at", "de"], // country Austria - German
  ["au", "en"], // country Australia - English
  ["ax", "sv"], // country Åland Islands - Swedish
  ["az", "az"], // country Azerbaijan - Azerbaijani
  ["be", "nl"], // country Belgium - Dutch
  ["bd", "bn"], // country Bangladesh - Bengali
  ["bg", "bg"], // country Bulgaria - Bulgarian
  ["bh", "en"], // country Bahrain - English (should possibly be Arabic)
  ["bm", "en"], // country Bermuda - English
  ["bn", "en"], // country Brunei - English (should possibly be Negara Brunei Darussalam)
  ["br", "pt"], // country Brazil - Portuguese
  ["bt", "dz"], // country Bhutan - Dzongkha
  ["bw", "en"], // country Botswana - English
  ["by", "be"], // country Belarus - Belarusian
  ["ca", "en"], // country Canada - English
  ["cf", "fr"], // country Central African Republic - French
  ["cg", "fr"], // country Republic of the Congo - French
  ["ch", "de"], // country Switzerland - German
  ["ci", "fr"], // country Cote D'Ivoire - French
  ["cl", "es"], // country Chile - Spanish
  ["cn", "zh"], // country China - Chinese
  ["co", "es"], // country Colombia - Spanish
  ["cy", "el"], // country Cyprus - Greek
  ["cz", "cs"], // country Czech Republic - Czech
  ["de", "de"], // country Germany - German
  ["dj", "fr"], // country Djibouti - French
  ["dk", "da"], // country Denmark - Danish
  ["do", "es"], // country Dominican Republic - Spanish
  ["dz", "ar"], // country Algeria - Arabic
  ["ee", "et"], // country Estonia - Estonian
  ["eg", "ar"], // country Egypt - Arabic
  ["es", "es"], // country Spain - Spanish
  ["et", "en"], // country Ethiopia - English (this _should_ be Amharic, but its code clashes with legacy language code for Armenian)
  ["fi", "fi"], // country Finland - Finnish
  ["fj", "en"], // country Fiji - English
  ["fk", "en"], // country Falkland Islands - English
  ["fm", "en"], // country Micronesia - English
  ["fo", "fo"], // country Faroe Islands - Faroese
  ["fr", "fr"], // country France - French
  ["ga", "fr"], // country Gabon - French
  ["gb", "en"], // country United Kingdom - English
  ["ge", "ka"], // country Georgia - Georgian
  ["gf", "fr"], // country French Guiana - French
  ["gg", "en"], // country Guernsey - English
  ["gh", "en"], // country Ghana - English
  ["gi", "en"], // country Gibraltar - English
  ["gl", "kl"], // country Greenland - Greenlandic
  ["gn", "fr"], // country Guinea - French
  ["gr", "el"], // country Greece - Greek
  ["gy", "en"], // country Guyana - English
  ["hk", "zh"], // country Hong Kong - Chinese
  ["hr", "hr"], // country Croatia - Croatian
  ["hu", "hu"], // country Hungary - Hungarian
  ["id", "id"], // country Indonesia - Indonesian
  ["ie", "en"], // country Ireland - English
  ["il", "he"], // country Israel - Hebrew
  ["in", "hi"], // country India - Hindi
  ["iq", "ar"], // country Iraq - Arabic
  ["is", "is"], // country Iceland - Icelandic
  ["it", "it"], // country Italy - Italian
  ["je", "en"], // country Jersey - English
  ["jo", "ar"], // country Jordan - Arabic
  ["jp", "ja"], // country Japan - Japanese
  ["ke", "en"], // country Kenya - English
  ["kh", "km"], // country Cambodia - Khmer
  ["kr", "ko"], // country South Korea - Korean
  ["kw", "ar"], // country Kuwait - Arabic
  ["kz", "kk"], // country Kazakhstan - Kazakh
  ["la", "lo"], // country Laos - Lao
  ["lb", "ar"], // country Lebanon - Arabic
  ["li", "de"], // country Liechtenstein - German
  ["lk", "ta"], // country Sri Lanka - Tamil
  ["lt", "lt"], // country Lithuania - Lithuanian
  ["lu", "fr"], // country Luxembourg - French
  ["lv", "lv"], // country Latvia - Latvian
  ["ly", "ar"], // country Libya - Arabic
  ["ma", "ar"], // country Morocco - Arabic
  ["me", "sr"], // country Montenegro - Serbian
  ["mk", "mk"], // country North Macedonia - Macedonian
  ["mm", "en"], // country Myanmar - English (this _should_ be Burmese, but its code clashes with legacy language code for Malay)
  ["mn", "mn"], // country Mongolia - Mongolian
  ["mo", "zh"], // country Macau - Chinese (Cantonese)
  ["mt", "mt"], // country Malta - Maltese
  ["mu", "en"], // country Mauritius - English
  ["mv", "en"], // country Maldives - English (no country-name data for Dhivehi upstream)
  ["mx", "es"], // country Mexico - Spanish
  ["my", "ms"], // country Malaysia - Malay
  ["mz", "pt"], // country Mozambique - Portuguese
  ["na", "en"], // country Namibia - English
  ["nc", "fr"], // country New Caledonia - French
  ["ne", "fr"], // country Niger - French
  ["ng", "en"], // country Nigeria - English
  ["nl", "nl"], // country Netherlands - Dutch
  ["no", "no"], // country Norway - Norwegian
  ["np", "ne"], // country Nepal - Nepali
  ["nz", "en"], // country New Zealand - English
  ["om", "ar"], // country Oman - Arabic
  ["pa", "es"], // country Panama - Spanish
  ["pe", "es"], // country Peru - Spanish
  ["pg", "en"], // country Papua New Guinea - English
  ["ph", "en"], // country Philippines - English
  ["pk", "ur"], // country Pakistan - Urdu
  ["pl", "pl"], // country Poland - Polish
  ["pr", "es"], // country Puerto Rico - Spanish
  ["pt", "pt"], // country Portugal - Portuguese
  ["py", "es"], // country Paraguay - Spanish
  ["qa", "ar"], // country Qatar - Arabic
  ["re", "fr"], // country Réunion - French
  ["ro", "ro"], // country Romania - Romanian
  ["rs", "sr"], // country Serbia - Serbian
  ["ru", "ru"], // country Russia - Russian
  ["rw", "en"], // country Rwanda - English
  ["sa", "ar"], // country Saudi Arabia - Arabic
  ["sc", "en"], // country Seychelles - English
  ["se", "sv"], // country Sweden - Swedish
  ["sg", "en"], // country Singapore - English
  ["sh", "en"], // country Saint Helena, Ascension and Tristan da Cunha - English
  ["si", "sl"], // country Slovenia - Slovenian
  ["sk", "sk"], // country Slovakia - Slovak
  ["sl", "en"], // country Sierra Leone - English
  ["sn", "fr"], // country Senegal - French
  ["so", "en"], // country Somalia - English
  ["sr", "nl"], // country Suriname - Dutch
  ["sz", "en"], // country Eswatini - English
  ["tg", "fr"], // country Togo - French
  ["th", "th"], // country Thailand - Thai
  ["tj", "tg"], // country Tajikistan - Tajik
  ["tn", "ar"], // country Tunisia - Arabic
  ["tr", "tr"], // country Turkey - Turkish
  ["tt", "en"], // country Trinidad and Tobago - English
  ["tw", "zh"], // country Taiwan - Chinese
  ["tz", "en"], // country Tanzania - English
  ["ua", "uk"], // country Ukraine - Ukrainian
  ["ug", "sw"], // country Uganda - Swahili
  ["um", "en"], // country United States Minor Outlying Islands - English
  ["us", "en"], // country United States - English
  ["uy", "es"], // country Uruguay - Spanish
  ["uz", "uz"], // country Uzbekistan - Uzbek
  ["ve", "es"], // country Venezuela - Spanish
  ["vg", "en"], // country Virgin Islands (British) - English
  ["vi", "en"], // country Virgin Islands (U.S.) - English
  ["vn", "vi"], // country Vietnam - Vietnamese
  ["vu", "en"], // country Vanuatu - English (no country-name data for Bislama upstream)
  ["za", "en"], // country South Africa - English
  ["zm", "en"], // country Zambia - English
  ["zw", "en"], // country Zimbabwe - English
] as const);

export const languageMappings = new Map([
  ["en", "int"],
  ["sv", "se"],
  ["da", "dk"],
  ["be", "by"],
  ["cs", "cz"],
  ["hi", "in"],
  ["kk", "kz"],
  ["lb", "lu"],
  ["ms", "my"],
  ["uk", "ua"],
  ["zh", "cn"],
] as const);

export const languageMappingsReverse = new Map(
  Array.from(languageMappings, ([real, fake]) => [fake, real]),
);

export const toIso = (language_code: string) =>
  languageMappingsReverse.get(language_code as any) ?? language_code;

export const fromIso = (language_code: string) =>
  languageMappings.get(language_code as any) ?? language_code;

const uiLanguageMap: Record<string, UiLanguage> = {
  no: "no",
  sv: "se",
  da: "dk",
  fi: "fi",
  fr: "fr",
  de: "de",
};

export function getDefaultUiLanguageForLanguage(
  language: string | undefined,
): UiLanguage {
  if (!language) {
    return "int";
  }

  const mapped = uiLanguageMap[language];

  return mapped ?? "int";
}

export type UiLanguage = (typeof uiLanguages)[number];
